import { CategoryInfo } from './types'

export const categories: CategoryInfo[] = [
  { id: 'greetings', name: '问候语', nameEn: 'Greetings', icon: '👋', color: 'bg-pink-500' },
  { id: 'numbers', name: '数字', nameEn: 'Numbers', icon: '🔢', color: 'bg-blue-500' },
  { id: 'family', name: '家庭', nameEn: 'Family', icon: '👨‍👩‍👧‍👦', color: 'bg-purple-500' },
  { id: 'food', name: '食物', nameEn: 'Food', icon: '🍜', color: 'bg-orange-500' },
  { id: 'animals', name: '动物', nameEn: 'Animals', icon: '🐾', color: 'bg-green-500' },
  { id: 'colors', name: '颜色', nameEn: 'Colors', icon: '🎨', color: 'bg-red-500' },
  { id: 'body', name: '身体', nameEn: 'Body', icon: '🫀', color: 'bg-rose-500' },
  { id: 'time', name: '时间', nameEn: 'Time', icon: '⏰', color: 'bg-yellow-500' },
  { id: 'weather', name: '天气', nameEn: 'Weather', icon: '🌤️', color: 'bg-cyan-500' },
  { id: 'school', name: '学校', nameEn: 'School', icon: '🏫', color: 'bg-indigo-500' },
  { id: 'places', name: '地方', nameEn: 'Places', icon: '📍', color: 'bg-teal-500' },
  { id: 'verbs', name: '动词', nameEn: 'Verbs', icon: '🏃', color: 'bg-amber-500' },
  { id: 'adjectives', name: '形容词', nameEn: 'Adjectives', icon: '✨', color: 'bg-violet-500' },
  { id: 'daily', name: '日常', nameEn: 'Daily', icon: '🏠', color: 'bg-lime-500' },
]
